var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHilo = function SvgHilo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 34919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 22C2 16.4142 2 13.6213 2.78563 11.3761C4.1928 7.35464 7.35464 4.1928 11.3761 2.78563C13.6213 2 16.4142 2 22 2C27.5858 2 30.3787 2 32.6239 2.78563C36.6454 4.1928 39.8072 7.35464 41.2144 11.3761C42 13.6213 42 16.4142 42 22C42 27.5858 42 30.3787 41.2144 32.6239C39.8072 36.6454 36.6454 39.8072 32.6239 41.2144C30.3787 42 27.5858 42 22 42C16.4142 42 13.6213 42 11.3761 41.2144C7.35464 39.8072 4.1928 36.6454 2.78563 32.6239C2 30.3787 2 27.5858 2 22Z",
    fill: "url(#paint0_linear_4916_3515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.78563 11.3761C2 13.6213 2 16.4142 2 22H42C42 16.4142 42 13.6213 41.2144 11.3761C39.8072 7.35464 36.6454 4.1928 32.6239 2.78563C30.3787 2 27.5858 2 22 2C16.4142 2 13.6213 2 11.3761 2.78563C7.35464 4.1928 4.1928 7.35464 2.78563 11.3761Z",
    fill: "url(#paint1_linear_4916_3515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18L22 7L32 18H12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2666 28.7101L22.0324 35L27.7982 28.7101H16.2666Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4916_3515",
    x1: 2,
    y1: 22,
    x2: 42,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E01F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0131B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4916_3515",
    x1: 22,
    y1: 2,
    x2: 22,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDA700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA700"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHilo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hilo.a6d658f8.svg";
export { ForwardRef as ReactComponent };